<template>
  <transition name="fade">
    <div class="userModal" v-if="show">
      <div class="overlay"></div>
      <div :class="{modalContent: true, modalBig: true}">
        <div class="loading" v-if="loading"></div>
        <div class="close" v-on:click="close(false)"></div>
        <h4 v-if="isEdit">Edit Icon Slider</h4>
        <h4 v-else>Add Icon Slider</h4>
        <form v-on:submit.prevent="handleSubmit">
          <div class="formCnt">
            <div class="fieldGroup">
              <div class="fieldCnt">
                <label>Icon</label>
                <div class="mediaCnt">
                  <div class="field" v-on:click="addImage">
                    <div class="fieldImg" v-if="media && media[lang]"
                      :style="{'background-image': `url(${media[lang].imageSm})`}"></div>
                    <div class="fieldImg noImg" v-else></div>
                    <div class="mediaLabel" v-if="media && media[lang] && media[lang].name">
                      {{media[lang].name}}</div>
                    <div class="mediaLabel" v-else-if="media && media[lang]">
                      Selected Media</div>
                    <div class="mediaLabel" v-else>Select Media</div>
                    <div class="fieldMore" v-if="media && media[lang]"
                      v-on:click.stop="media[lang] = null"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="fieldGroup">
              <div class="fieldCnt">
                <label>Name</label>
                <input type="text" class="field" placeholder="Name..."
                  v-model="form.title[lang]">
              </div>
            </div>
            <div class="fieldGroup">
              <div class="fieldCnt">
                <label>Descriptions</label>
                <textarea rows="2" type="text" class="field" placeholder="Descriptions..."
                  v-model="form.descriptions[lang]"></textarea>
              </div>
            </div>
            <div class="fieldGroup fg2b">
              <div class="fieldCnt">
                <label>Url</label>
                <input type="text" class="field" placeholder="https://..."
                  v-model="form.url.model">
              </div>
              <div class="fieldCnt">
                <label>Button Label</label>
                <input type="text" class="field" placeholder="Button label..."
                  v-model="form.buttonLabel[lang]">
              </div>
            </div>
          </div>
          <div class="modalAction" :class="{saveDisabled: !media.id || !media.en}">
            <div class="langSelectorBtn"
              v-on:click.stop="langSelectorOpen = !langSelectorOpen">
              <b>{{lang}}</b>
              <div class="langSelector" v-if="langSelectorOpen"
                v-on:click.stop="doNothing">
                <li v-on:click.stop="selectLang('en')">EN - English</li>
                <li v-on:click.stop="selectLang('id')">ID - Bahasa Indonesia</li>
              </div>
            </div>

            <button class="btn btnSecondary" type="button"
              v-on:click="close(false)" v-if="!saving">
              Cancel
            </button>
            <button class="btn btnPrimary" v-if="isEdit && !saving">
              Save Changes
            </button>
            <button class="btn btnPrimary" v-if="!isEdit && !saving">
              Add Icon Slider
            </button>
            <button class="btn btnPrimary saving" type="button" v-if="saving">
              Saving...
            </button>
          </div>
        </form>
      </div>
      <MediaSelector ref="mediaSelector"/>
    </div>
  </transition>
</template>

<script>
import MediaSelector from '@/components/MediaSelector.vue';

export default {
  components: { MediaSelector },
  data() {
    return {
      isEdit: null,
      loading: false,
      show: false,
      saving: false,
      media: { id: null, en: null },
      form: {
        title: { id: '', en: '', error: null },
        descriptions: { id: '', en: '' },
        buttonLabel: { id: '', en: '', error: null },
        url: { model: '', error: null },
      },
      langSelectorOpen: false,
      lang: 'id',
    };
  },
  methods: {
    doNothing() {},
    open(d, n) {
      this.isEdit = d !== null;
      this.form.title.id = (d && d.title) ? d.title.id : '';
      this.form.title.en = (d && d.title) ? d.title.en : '';
      this.form.descriptions.id = (d && d.descriptions) ? d.descriptions.id : '';
      this.form.descriptions.en = (d && d.descriptions) ? d.descriptions.en : '';
      this.form.buttonLabel.id = (d && d.buttonLabel) ? d.buttonLabel.id : '';
      this.form.buttonLabel.en = (d && d.buttonLabel) ? d.buttonLabel.en : '';
      this.form.url.model = (d && d.url) ? d.url : '';
      this.media.id = (d && d.media) ? d.media.id : null;
      this.media.en = (d && d.media) ? d.media.en : null;
      this.next = n;
      this.show = true;
      this.saving = false;
      this.lang = 'id';
      document.getElementsByTagName('BODY')[0].classList.add('stopscroll');
    },
    close(b, d) {
      this.show = false;
      document.getElementsByTagName('BODY')[0].classList.remove('stopscroll');
      if (this.next && typeof this.next === 'function') this.next(b, d);
    },
    selectLang(lang) {
      this.lang = lang;
      this.langSelectorOpen = false;
    },
    addImage() {
      this.$refs.mediaSelector.open(null, (b, media) => {
        if (!b) return;
        const m = (media.gallery) ? media.gallery[0] : media;
        if (m.type !== 'image') {
          this.$refs.confirmDialog.open({
            title: 'Media Not Supported',
            desc: 'Only support image media type for logo',
            error: true,
          });
          return;
        }
        this.media[this.lang] = m;
      });
    },
    handleSubmit() {
      if (this.saving || !this.media.id || !this.media.en) return;
      const formData = {
        title: {
          id: this.form.title.id,
          en: this.form.title.en,
        },
        descriptions: {
          id: this.form.descriptions.id,
          en: this.form.descriptions.en,
        },
        buttonLabel: {
          id: this.form.buttonLabel.id,
          en: this.form.buttonLabel.en,
        },
        url: this.form.url.model,
        media: {
          id: this.media.id,
          en: this.media.en,
        },
      };
      this.close(true, formData);
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.formCnt{
  position: relative;
  // padding-left: 140px;
  overflow: auto;
  padding: 20px 80px 0;
  margin: 0 -80px;
  border-top: #eee 1px solid;
  max-height: 64vh;
}
.mediaCnt{
  .field{
    cursor: pointer;
    padding: 18px 40px 19px;
    padding-left: 64px;
    position: relative;
    .mediaLabel{
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-weight: 600;
      font-size: 17px;
    }
    .fieldImg{
      content: "";
      position: absolute;
      width: 46px; height: 46px;
      background-color: #eee;
      border-radius: 5px;
      left: 6px; top: 6px;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      &.noImg{
        background-color: #ccc;
        background-image: url(../assets/image-black.png);
        background-size: 22px auto;
        opacity: .36;
        &.video{
          background-image: url(../assets/video-black.png);
        }
      }
    }
    .fieldMore{
      position: absolute;
      right: 8px; top: 11px;
      width: 34px; height: 34px;
      border-radius: 50%;
      background-size: 12px auto;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url(../assets/close.png);
      opacity: .36;
      cursor: pointer;
      transition: all .3s ease;
      &:hover{
        background-color: #ccc;
        opacity: .64;
      }
    }
  }
}
.userModal{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 991;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  padding: 40px 0;

  .addCategory{
    color: #0245a7;
    display: inline-block;
    float: right;
    border-radius: 50px;
    margin-top: 4px;
    padding: 4px 10px 6px;
    cursor: pointer;
    &:hover{
      background-color: #eee;
    }
    img{
      height: 18px;
      float: left;
      margin-right: 7px;
      margin-top: 1px;
    }
  }

  .fieldGroup{
    &.fg2b{
      .fieldCnt:first-child{
        width: calc(62% - 10px);
      }
      .fieldCnt:last-child{
        width: calc(38% - 10px);
      }
    }
  }

  .fieldCnt{
    position: relative;
    .fieldLoading{
      position: absolute;
      right: 10px; top: 33px;
      z-index: 3;
      img{
        height: 24px;
      }
    }
    .theMan{
      position: relative;
      border-radius: 5px;
      border: #ccc 1px solid;
      display: flex;
      align-items: center;
      border-color: #0e5dd2;
      background-color: #e9f2ff;
      padding-left: 54px;
      padding-right: 38px;
      box-sizing: border-box;
      height: 48px;
      h5{
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        font-size: 17px;
        color: #0747a6;
        font-weight: 600;
        margin: 0;
      }
      .profilePict{
        width: 36px; height: 36px;
        position: absolute;
        left: 10px; top: 50%;
        margin-top: -18px;
        background-color: #0e5dd2;
        border-radius: 50%;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        &.email{
          background-color: #e9f2ff;
          background-image: url(../assets/envelope.png);
          background-size: 18px auto;
          background-position: center;
          background-repeat: no-repeat;
        }
      }
      .close{
        position: absolute;
        right: 6px; top: 50%;
        border-radius: 50%;
        margin-top: -15px;
        width: 30px; height: 30px;
        background-image: url(../assets/close.png);
        background-size: 12px auto;
        background-repeat: no-repeat;
        background-position: center;
        cursor: pointer;
        opacity: .5;
        // transition: all .2s ease;
        &:hover{
          opacity: .8;
          background-color: #fff;
        }
      }
      &.hasError{
        background-color: #fff4f4;
        border-color: red;
        h5{
          color: red;
        }
        .profilePict{
          background-color: red;
          &.email{
            background-color: #fff4f4;
          }
        }
      }
    }
  }
  .fieldCnt.hasError{
    .field{
      border-color: red;
    }
    .fieldHint{
      display: none;
    }
    .fieldError{
      display: block;
    }
  }
  .fieldCnt.hasPrefix{
    position: relative;
    .field{
      padding-left: 40px;
    }
    .fieldPrefix{
      position: absolute;
      left: 10px; top: 35px;
      z-index: 3;
      color: #767676;
    }
  }

  .overlay{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.7);
    z-index: 1;
    // backdrop-filter: saturate(180%) blur(20px);
  }
  .modalContent{
    position: relative;
    z-index: 2;
    background: #fff;
    margin: auto;
    border-radius: 5px;
    overflow: hidden;
    transition: all .3s ease;
    width: 480px;
    padding: 30px 80px 40px;
    .loading{
      position: absolute;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: #fff;
      background-color: rgba(255,255,255,.7);
      backdrop-filter: saturate(180%) blur(20px);
      background-image: url(../assets/loading-2.svg);
      background-position: center;
      background-size: 70px auto;
      background-repeat: no-repeat;
      z-index: 9;
    }
    .close{
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background-image: url(../assets/close.png);
      background-size: 14px auto;
      background-position: center;
      background-repeat: no-repeat;
      position: absolute;
      right: 10px;
      top: 10px;
      opacity: .4;
      cursor: pointer;
      transition: all .2s linear;
    }
    .close:hover{
      background-color: #e5e5e5;
      opacity: .7;
    }
    h4{
      font-size: 24px;
      margin: 0;
      // margin-left: 146px;
      font-weight: 600;
      margin-bottom: 10px;
      text-align: center;
    }
    .modalAction{
      text-align: right;
      border-top: #eee 1px solid;
      margin: 0 -80px -40px;
      padding: 12px 30px;
      display: flex;
      align-items: center;
      .langSelectorBtn{
        margin-right: auto;
        position: relative;
        border-radius: 50px;
        padding: 6px 16px;
        padding-left: 36px;
        transition: all .3s ease;
        cursor: pointer;
        margin-right: auto;
        &:hover{
          background-color: #f5f5fe;
        }
        &:before{
          content: "";
          position: absolute;
          left: 12px; top: 0; bottom: 3px;
          width: 18px;
          background-image: url(../assets/language.png);
          background-size: 18px auto;
          background-position: center;
          background-repeat: no-repeat;
        }
        b{
          font-weight: 600;
          text-transform: uppercase;
        }
        .langSelector{
          position: absolute;
          background-color: #fff;
          z-index: 7;
          bottom: 100%; left: 0;
          box-shadow: 0 0 6px rgba(0, 0, 0, .2);
          border-radius: 5px;
          padding: 8px 0;
          text-align: left;
          li{
            white-space: nowrap;
            list-style: none;
            padding: 8px 24px;
            cursor: pointer;
            transition: all .3s ease;
            &:hover{
              background-color: #f5f5fe;
            }
          }
        }
      }
      &.saveDisabled{
        .btnPrimary{
          background-color: #ccc;
          color: #999;
          box-shadow: none;
          cursor: default;
        }
      }
    }
    .btn{
      margin-left: 5px;
      &.saving{
        background-color: #ccc;
        color: #999;
        cursor: default;
        box-shadow: none;
      }
    }
  }
}
</style>
